/**
 * 属性（企画書 §9.3）。
 *
 * **バトル計算に使う**（ADR-027）。相性はすくみの輪（火 → 風 → 土 → 雷 → 水 → 火）と、
 * おたがいに つよい光と闇。無は相性なし。表と倍率は `@drawgon/game-engine` の
 * `ELEMENT_ADVANTAGE` / `ELEMENT_ADVANTAGE_MULTIPLIER`。
 *
 * 企画書 §9.3 は「MVP では系統のみ、または属性は演出のみでもよい」、§28 は「複雑な属性相性」を
 * 後回しにしている。単純なすくみで、倍率をバランス検証（§38 Task 3）で小さく決めたうえで入れた。
 * 相性を増やす・倍率を上げるときは、`sim` で測り直して ADR を更新する。
 */
export const ELEMENT_IDS = [
    'fire',
    'water',
    'thunder',
    'wind',
    'earth',
    'light',
    'dark',
    'none',
];
export const ELEMENTS = {
    fire: { id: 'fire', name: '火' },
    water: { id: 'water', name: '水' },
    thunder: { id: 'thunder', name: '雷' },
    wind: { id: 'wind', name: '風' },
    earth: { id: 'earth', name: '土' },
    light: { id: 'light', name: '光' },
    dark: { id: 'dark', name: '闇' },
    none: { id: 'none', name: '無' },
};
